import React from 'react'
import { FaFacebook, FaTwitterSquare, FaInstagram } from "react-icons/fa"

export default [
    {
        icon: <FaFacebook/>,
        url: "https://www.facebook.com/Frida-Travel-332230344312675",
    },
    {
        icon: <FaTwitterSquare/>,
        url: "https://twitter.com/_fridatravel",
    },
    {
        icon: <FaInstagram/>,
        url: "https://www.instagram.com/fridatravel_",
    },
]